<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/intake'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary" 
    :ref="'intake-variety'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: null,
        Name: null,
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Intake Variety",
        pageRoute: "/intake-variety",
        saveEndPoint: "AlmondcoIntakeVariety",
        updateEndPoint: "AlmondcoIntakeVariety",
        updateKeyField: "Code",
        updateKeyFieldType: "String",
        recordEndPoint: "AlmondcoIntakeVariety",
        exportFileName: "Intake Varieties List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoIntakeVariety",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "Code", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "intake-variety",
              mode: "review",
              idProperty: "Code",
              idMode: "String",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/intake-variety/create",
                clickAction: () => {
                  this.goToCreateIntakeVariety();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                   "AlmondcoIntakeSettings",
                   "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              dataField: "Code",
            },
            {
              screenField: "Name",
              allowHiding: false,
              dataField: "Name",
              label: "Description",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                  maxLength: 3,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "Name",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 2,
                  maxLength: 25,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        "create"
      );
    },
  },
  methods: {
    goToCreateIntakeVariety() {
      this.$router
        .push({
          path: `/intake-variety/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      return payload;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
